import emailjs from "@emailjs/browser";
import React, { useState } from "react";
import { useAppStore } from "../../stores";
import { EMAILJS_PUBLIC_KEY, EMAILJS_SERVICE_ID, EMAILJS_TEMPLATE_ID } from "../../utils/client";
import "./index.scss";

const FeedbackForm = () => {
	const appStore = useAppStore((state) => state);

	const [message, setMessage] = useState("");
	const [email, setEmail] = useState("");
	const [status, setStatus] = useState("");
	const [loading, setLoading] = useState(false);

	const handleSubmit = async (event) => {
		event.preventDefault();
		setLoading(true);
		setStatus("Отправка...");

		try {
			await emailjs.send(
				EMAILJS_SERVICE_ID,
				EMAILJS_TEMPLATE_ID,
				{
					user_email: email,
					message: message,
				},
				EMAILJS_PUBLIC_KEY
			);

			setStatus("Спасибо! Ваше обращение отправлено.");
			setMessage("");
			setEmail("");
			setLoading(false);
		} catch (error) {
			console.error("Ошибка:", error);
			setStatus("Произошла ошибка при отправке.");
			setLoading(false);
		}
	};

	return (
		<div className="feedback">
			<h5 className="mb-3">{appStore.phrases?.["feedback"]}</h5>
			<form className="feedback-form" onSubmit={handleSubmit}>
				<label htmlFor="email">{appStore.phrases?.["feedback-label"]}</label>
				<input
					type="text"
					value={email}
					onChange={(e) => setEmail(e.target.value)}
					className="form-control"
					required
					placeholder={appStore.phrases?.["email"]}
					name="user_email"
				/>
				<input
					type="text"
					name="message"
					className="form-control"
					value={message}
					onChange={(e) => setMessage(e.target.value)}
					required
					placeholder={appStore.phrases?.["feedbackPlaceholder"]}
				/>
				<button type="submit" disabled={loading}>
					{appStore.phrases?.["send"]}
				</button>
				{status && <p>{status}</p>}
			</form>
		</div>
	);
};

export default FeedbackForm;
